<template>
    <div class="calendar-view">
        <app-overlay-loader v-if="preloader"/>
        <FullCalendar v-else :options="calendarOptions"/>
    </div>
</template>

<script>

import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';

export default {
    name: "Calendar",
    components: {
        FullCalendar
    },
    props: {
        options: {
            type: Object
        },
        preloader: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            initOptions: {
				schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
				locale: 'ru',
                plugins: [resourceTimelinePlugin],
                headerToolbar: {
                    left: 'title',
                    center: 'prev today next',
                     right: 'resourceTimelineMonth,resourceTimelineWeek',
					Resources:    'dsd',
  					
                },
                initialView: 'resourceTimelineMonth',
                selectable: true,
                views: {
					 resourceTimelineMonth: {
                        titleFormat: {month: 'long', year: 'numeric'}
                    },
					 resourceTimelineWeek: {
                        titleFormat: {month: 'long', year: 'numeric'},
                        weekNumbers: true
                    },
                },


            }
        }
    },
    computed: {
        calendarOptions() {
            return {
                ...this.initOptions,
                slotLabelFormat: this.slotLabel
                , ...this.options
            }
        },
        slotLabel() {
            if (this.$store.state.settings.timeFormat === 12) return undefined;
            return {
                'hour12': false,
                'hour': '2-digit',
                'minute': '2-digit'
            }
        }
    }
}
</script>
